import { render, staticRenderFns } from "./userAgreement.vue?vue&type=template&id=5153d9e0&scoped=true&"
var script = {}
import style0 from "./userAgreement.vue?vue&type=style&index=0&id=5153d9e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5153d9e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5153d9e0')) {
      api.createRecord('5153d9e0', component.options)
    } else {
      api.reload('5153d9e0', component.options)
    }
    module.hot.accept("./userAgreement.vue?vue&type=template&id=5153d9e0&scoped=true&", function () {
      api.rerender('5153d9e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/my/userAgreement.vue"
export default component.exports